import { FC, MouseEvent } from 'react';
import { useDisclosure, useMediaQuery, Wrap, WrapItem } from '@chakra-ui/react';
import { saveAs } from 'file-saver';
import {
  AppleCalendar,
  CalendarAdd,
  ExportCalendar,
  GoogleCalendar,
  OutlookCalendar,
} from '../../assets';
import { buildCalendarUrl, CalendarEvent, CalendarOptions } from '../../utils';
import { Modal } from '../modal';
import { CalendarLink } from './CalendarLink';

export interface AddToCalendarProps {
  eventData?: CalendarEvent;
}

export const AddToCalendar: FC<AddToCalendarProps> = ({ eventData }) => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const { onClose, onOpen, isOpen } = useDisclosure();

  const handleCalendarType = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = e.currentTarget.getAttribute('href') as string;
    const blob = new Blob([url], { type: 'text/calendar;charset=utf-8' });
    saveAs(blob, 'download.ics');
  };

  const event = eventData || {};

  const { google, apple, outlook, exportEvent } = CalendarOptions;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        colorScheme: 'blue',
        title: 'Add to Calendar',
        variant: 'secondary',
        leftIcon: <CalendarAdd boxSize="16px" />,
        onClick: onOpen,
      }}
      modalTitle="Add to calendar"
      size={isMobile ? 'xs' : 'xl'}
    >
      <Wrap justify="center" spacing={4}>
        <WrapItem>
          <CalendarLink
            href={buildCalendarUrl({ event, type: google })}
            imgSrc={GoogleCalendar}
            name={google}
          />
        </WrapItem>
        <WrapItem>
          <CalendarLink
            href={buildCalendarUrl({ event, type: apple })}
            imgSrc={AppleCalendar}
            name={apple}
            onClick={handleCalendarType}
          />
        </WrapItem>
        <WrapItem>
          <CalendarLink
            href={buildCalendarUrl({ event, type: outlook })}
            imgSrc={OutlookCalendar}
            name={outlook}
            onClick={handleCalendarType}
          />
        </WrapItem>
        <WrapItem>
          <CalendarLink
            href={buildCalendarUrl({ event, type: exportEvent })}
            imgSrc={ExportCalendar}
            name={exportEvent}
            onClick={handleCalendarType}
          />
        </WrapItem>
      </Wrap>
    </Modal>
  );
};
